export default __webpack_public_path__ + "static/media/central.5dfb0b6b.png";